import {
	ContactIndicatorInitialPatient,
	ContactIndicatorPatient,
	useContactIndicatorModalViewModel,
} from "../useContactIndicatorModalViewModel";

export type PatientReevaluation = ContactIndicatorPatient;

const config = {
	indicator: "PRONTOS_REAVALIACAO" as const,
	stateKey: "prontosReavaliacao" as const,
	contactOrigin: "REEVALUATION" as const,
	message: (firstName: string, clinicName: string) =>
		`Olá, ${firstName}! Aqui é da ${clinicName}. Gostaríamos de acompanhar sua evolução. Podemos combinar uma reavaliação?`,
};

export const useReadyForReevaluationModalViewModel = (
	isOpen: boolean,
	initialPatient?: ContactIndicatorInitialPatient | null,
	onContactStarted?: (patientId: string) => void
) =>
	useContactIndicatorModalViewModel(isOpen, config, {
		initialPatient,
		onContactStarted,
	});
